export const GET_USER_STREAKS_PATH = 'api/landlord/user-streaks';